<div class="outside-box">
  <div class="inside-box">
    <mat-card class="login-card">
      <div class="logo-container">
        <img src="/logo.png" alt="Company Logo" class="login-logo" />
      </div>

      <mat-card-header>
        <mat-card-title>Select Verification Method</mat-card-title>
        <mat-card-subtitle>
          Choose a phone number to receive your verification code
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="phoneForm" (ngSubmit)="onSubmit()" class="login-form">
          <div class="phone-list">
            <mat-radio-group formControlName="phoneNumber" class="radio-group">
              <mat-radio-button
                *ngFor="let phone of phoneNumbers"
                [value]="phone"
                class="radio-button"
              >
                {{ formatPhone(phone) }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="form-actions">
            <button
              mat-flat-button
              color="primary"
              type="submit"
              class="submit-button"
              [disabled]="phoneForm.invalid || accountService.isLoading"
            >
              Send Code
            </button>
          </div>
        </form>
      </mat-card-content>

      <mat-card-actions class="additional-actions">
        <a routerLink="/login" class="action-link">Back to Login</a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>